import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_find_serialnumbersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, vendorLotId?: number, materialId?: number, projectId?: number, archived?: boolean }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LotId?: number, PackagingId?: number, Lot?: { Id?: number, LookupCode?: string, StatusId?: number, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number } } }[] }> 
  {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_find_serialnumbers/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, vendorLotId?: number, materialId?: number, projectId?: number, archived?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LotId?: number, PackagingId?: number, Lot?: { Id?: number, LookupCode?: string, StatusId?: number, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_find_serialnumbers/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, vendorLotId?: number, materialId?: number, projectId?: number, archived?: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LotId?: number, PackagingId?: number, Lot?: { Id?: number, LookupCode?: string, StatusId?: number, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_find_serialnumbers/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, lookupcode?: string, licenseplateId?: number, lotId?: number, packagingId?: number, vendorLotId?: number, materialId?: number, projectId?: number, archived?: boolean    }) {
      return false;
    }
}
